import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-timeline-message',
  templateUrl: './timeline-message.component.html',
  styleUrls: ['./timeline-message.component.scss']
})
export class TimelineMessageComponent {

  message_logo = "./assets/images/instaloanOnlyLogo.svg";
  message = "Instaloan request for transactional, balance and profile data";
  time = "20 Aug 2018, 10.15 AM"
  test;

  timelineData;

  getTimeline: {
    message: "Consent timeline is accessible"
  }

  @Input()
  consentEvent;

  constructor(){
  }
}
